/* eslint-disable i18next/no-literal-string */
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line no-restricted-imports
import { Button } from 'semantic-ui-react';
import { ViewComponentProps } from '../../../common';
import { useOrganization } from '../../../hooks/useOrganizations';

const InvitationMessageView: React.FC<ViewComponentProps> = ({ title, hasTitle = true }) => {
  const { t } = useTranslation();
  const organization = useOrganization();
  const viewTitle = hasTitle ? t(title || 'enrollments.invitationMessageViewTitle') : '';

  return (
    <div className="invitation-message-view">
      <h2>{viewTitle}</h2>
      <div className="invitation-message">
        <p>{t('enrollments.invitationMessage.greeting')}</p>
        <p>We are excited to invite [student's name] to enroll in {organization.name}</p>
        <p>
          Please click the button below to create your account on the Wonderschool platform so we can get the enrollment
          process started.
        </p>
        <p>
          <Button disabled>Get started</Button>
        </p>
        <p>
          <strong>What is Wonderschool?</strong>
        </p>
        <p>
          Wonderschool connects parents with childcare providers which allows you to record your child's activities, do
          touchless check-in/check-out, post photos and videos, and many more things.
        </p>
        <p>After you create your account, download the app on your phone and you are all set!</p>
        <p>Warmly,</p>
        <p>The Wonderschool Team</p>
      </div>
    </div>
  );
};
export default InvitationMessageView;
